export const pss_item = [
  {
    pss_item_nombre: "Actualización del Programa Sectorial de Salud 2022-2028",
    pss_item_url: "/contenido/informacion/publicaciones/ACTUALIZACION_PROGRAMA_SECTORIAL_SALUD_22_28.pdf",
    pss_item_titulo: ""
  },
  {
    pss_item_nombre: "Programa Sectorial de Salud 2023-2028",
    pss_item_url: "/contenido/informacion/publicaciones/1. PROGRAMA _SECTORIAL_SALUD_23_28.pdf",
    pss_item_titulo: ""
  },
  {
    pss_item_nombre: "Programa Sectorial de Salud",
    pss_item_url: "/contenido/informacion/publicaciones/2. PROGRAMA _SECTORIAL_SALUD_2016-2022.pdf",
    pss_item_titulo: ""
  },
  {
    pss_item_nombre: "Actualización del Programa Sectorial de Salud 2020-2022",
    pss_item_url: "/contenido/informacion/publicaciones/3. ACTUALIZACION_PROGRAMA _SECTORIAL_SALUD_2020-2022.pdf",
    pss_item_titulo: ""
  }
];
